/**
 * ApiService by karora on 22/03/17.
 */
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

import { ApiResponse } from '../types/apiresponse';
import { TokenInterceptor } from './token.interceptor.service';

@Injectable()
export class ApiService implements OnInit {
  private static userId: string = null;
  private static baseHeaders: HttpHeaders;
  private static tokenObserver: ReplaySubject<Object>;

  static readonly APIKey: string = '7596676d-8fed-475f-8588-6188bce4d0c5';

  constructor(
    private http: HttpClient,
  ) {
    ApiService.tokenObserver = null;
    try {
      // set token if saved in local storage
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser) {
        ApiService.userId = currentUser.userId;
        TokenInterceptor.SetAuthToken(currentUser.token);
      }
      ApiService.baseHeaders = new HttpHeaders({
        'Content-Type': 'application/json',
        'API-Key': ApiService.APIKey,
      });
      this.GetToken();
    } catch (e) {
      console.log(e);
    }
  }

  ngOnInit(): void {
    try {
      console.log("OnInit...");
      // this.GetToken();
    } catch (e) {
      console.log(e);
    }
  }

  public static RequestHeaders(): HttpHeaders {
    // console.log("Adding request headers");
    return ApiService.baseHeaders;
  }

  GetToken(): Observable<Object> {
    // console.log("GetToken...");
    if (ApiService.tokenObserver == null) {
      console.log("Really GetToken...");
      ApiService.tokenObserver = new ReplaySubject<Object>();
      this.http.get<ApiResponse>(window['apiBaseURL'] + '/auth/token').subscribe({
        next: jd => {
          try {
            // console.log("handleTokenResponse: "+JSON.stringify(jd, null, 2));
            if (jd.status === "success" && jd.data && jd.data.token) {
              let currentUser: any;
              try {
                currentUser = JSON.parse(localStorage.getItem('currentUser'));
              } catch (e) { }
              if (!currentUser) {
                currentUser = <any>{};
              }
              currentUser.authToken = jd.data.token;
              currentUser.id = jd.data.id;
              localStorage.setItem('currentUser', JSON.stringify(currentUser));
              TokenInterceptor.SetAuthToken(jd.data.token);

              ApiService.userId = jd.data.id;
              ApiService.tokenObserver.next(jd);
              ApiService.tokenObserver.complete();
              return;
            }

            ApiService.tokenObserver.error(jd);
            ApiService.tokenObserver = null;
          } catch (e) {
            console.log(e);
            ApiService.tokenObserver.error(e);
            ApiService.tokenObserver = null;
          }
        },
        error: err => {
          console.log(err);
          ApiService.tokenObserver.error(err);
          ApiService.tokenObserver = null;
        },
      });
    }
    return ApiService.tokenObserver.asObservable();
  }


  Get(url: string, propagateErrors: boolean = false): Observable<any> {
    console.log("Get: " + url);
    let observer: Subject<HttpResponse<any>> = new Subject<HttpResponse<any>>();
    try {
      if (TokenInterceptor.AuthTokenValid()) {
        this.getRealURL(observer, url, propagateErrors);
      } else {
        this.GetToken().subscribe(
          () => this.getRealURL(observer, url, propagateErrors),
          error => observer.error(error),
          () => console.log("We're done")
        );
      }
    } catch (e) {
      console.log("Get: error: " + e);
    }
    return observer.asObservable();
  }

  getRealURL(observer: Subject<any>, url: string, propagateErrors: boolean = false): void {
    // console.log("GetRealURL: " + window['apiBaseURL'] + url);
    try {
      this.http.get(window['apiBaseURL'] + url, { headers: ApiService.RequestHeaders() })
        .subscribe(
          r => ApiService.getNext(<any>r, observer, url),
          error => ApiService.getError(error, observer, url, propagateErrors),
        );
    } catch (e) {
      console.log("GetRealURL: error: " + e);
    }
  }

  Post(url: string, body: string, propagateErrors: boolean = false): Observable<any> {
    // console.log("Post: " + window['apiBaseURL'] + url);
    let observer: Subject<any> = new Subject<any>();
    try {
      this.http.post(window['apiBaseURL'] + url, body, { headers: ApiService.RequestHeaders() })
        .subscribe(
          r => ApiService.getNext(<any>r, observer, url),
          error => ApiService.getError(error, observer, url, propagateErrors),
        );
    } catch (e) {
      console.log("Post: error: " + e);
    }
    return observer.asObservable();
  }

  static getNext(r: HttpResponse<any>, observer: Subject<HttpResponse<any>>, url: string): void {
    console.debug("getNext... " + url);
    observer.next(r);
  }

  static getError(err: any, observer: Subject<HttpResponse<any>>, url: string, propagateErrors: boolean = false): void {
    console.log("getError... " + JSON.stringify(err, null, 2));
    if (url === "/auth/token" || url === "/auth/profile" || err.status == 401 || propagateErrors) {
      if (err.status == 401) {
        console.log("Status: " + err.statusText);
        TokenInterceptor.Forget();
        ApiService.userId = null;
        ApiService.tokenObserver = null;
      }
      observer.error(err);
      return;
    }
  }

  static Forget(): void {
    // clear token remove user from local storage to log user out
    TokenInterceptor.Forget();
    localStorage.removeItem('currentUser');
  }
}
